'use strict';
import { addEvent } from '../addEvent/addEvent';
import Scrollbar from 'smooth-scrollbar';
import { smoothScrollbarTest } from '../smoothScrollbar/smoothScrollbarTest';

export const fullSiteMenu = class {
  fullSiteMenuContainer = null;
  fullSiteMenuButton = null;
  menuContainer = null;
  body = null;

  openingTime = 1000;
  closingTime = 1000;

  menuShow = false;
  smoothScrollbar = false;

  //classname dla elementow twozonych
  bodyClassName = 'full-site-menu';
  bodyMenuShowClassName = 'full-site-menu--show';
  fullSiteMenuButtonClassName = 'full-site-menu-button';
  fullSiteMenuButtonIconDivClassName = 'full-site-menu-button__icon';
  fullSiteMenuButtonLabelDivClassName = 'full-site-menu-button__label';

  //Classnames to read
  menuContainerClassName = 'header__menu-container';
  fullSiteMenuContainerClassName = 'full-site-menu-container';

  scrollbarElementClassName = 'full-site-menu-container--scrollbar';
  elementToScrollbarClassName = 'full-site-menu__content-container';

  constructor() {
    return this.init();
  }

  init = () => {
    this.menuContainer = document.getElementsByClassName(
      this.menuContainerClassName
    )[0];

    const fullSiteMenuContainer = document.getElementsByClassName(
      this.fullSiteMenuContainerClassName
    )[0];

    if (!this.menuContainer || !fullSiteMenuContainer) return false;
    this.fullSiteMenuContainer = fullSiteMenuContainer; //fullSiteMenuContainer.cloneNode(true);
    //fullSiteMenuContainer.remove();

    this.body = document.querySelector('body');
    this.body.classList.add(this.bodyClassName);

    this._createMenuContainer();
    this._createMenuButton();
    this._addEventToKey();
    this._addEventToElement(
      document.querySelector('.full-site-menu__close-button'),
      'click'
    );
    return this;
  };

  _createMenuContainer = () => {
    //this.menuContainer.appendChild(this.fullSiteMenuContainer);

    if (smoothScrollbarTest()) {
      this.fullSiteMenuContainer.classList.add(this.scrollbarElementClassName);

      const scroolElement = this.fullSiteMenuContainer.getElementsByClassName(
        this.elementToScrollbarClassName
      )[0];

      this.smoothScrollbar = Scrollbar.init(scroolElement, {
        damping: 0.1,
      });
    }
  };

  _createMenuButton = () => {
    if (this.fullSiteMenuButton) return;

    const svgBorder = '<svg><rect class="border" rx="10" ry="10"></rect></svg>';

    const iconDiv = document.createElement('div');
    iconDiv.classList.add(this.fullSiteMenuButtonIconDivClassName);
    const span = document.createElement('span');
    const span2 = document.createElement('span');
    const span3 = document.createElement('span');
    const span4 = document.createElement('span');
    iconDiv.appendChild(span);
    iconDiv.appendChild(span2);
    iconDiv.appendChild(span3);
    // iconDiv.appendChild(span4);

    const labelDiv = document.createElement('div');
    labelDiv.classList.add(this.fullSiteMenuButtonLabelDivClassName);
    labelDiv.innerHTML = '<span>Menu</span>';

    this.fullSiteMenuButton = document.createElement('div');
    this.fullSiteMenuButton.classList.add(this.fullSiteMenuButtonClassName);

    this.fullSiteMenuButton.appendChild(iconDiv);
    this.fullSiteMenuButton.appendChild(labelDiv);
    //this.fullSiteMenuButton.insertAdjacentHTML('beforeend', svgBorder);

    this.menuContainer.appendChild(this.fullSiteMenuButton);

    this._addEventToElement(this.fullSiteMenuButton, 'click');
  };

  _addEventToElement = (element, eventName) => {
    addEvent(element, eventName, e => {
      e.preventDefault();
      this._showMenu(!this.menuShow);
    });
  };

  _addEventToKey = () => {
    addEvent(document, 'keyup', e => {
      if (e.keyCode == 27 && this.menuShow) {
        this._showMenu(false);
      }
    });
  };

  _showMenu = show => {
    if (show) {
      this.body.classList.add(this.bodyMenuShowClassName);
      this.menuShow = true;
    } else {
      this.body.classList.remove(this.bodyMenuShowClassName);
      this.menuShow = false;
    }
  };
};
